import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=db124248&scoped=true&"
import script from "./mobileFooter.vue?vue&type=script&lang=js&"
export * from "./mobileFooter.vue?vue&type=script&lang=js&"
import style0 from "./mobileFooter.vue?vue&type=style&index=0&id=db124248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db124248",
  null
  
)

export default component.exports